<tpm-dialog-frame
  alt-theme
  [hasSticky]="true"
  [hasFooter]="true"
  [submitDisabled]="form.invalid"
  [header]="'CONTACT_DIALOG.title' | translate"
  [submitButtonLabel]="submitButtonLabel() | translate"
  [closeButtonLabel]="'APP.CLOSE' | translate"
  (submitted)="onSubmit()"
>
  <!-- sticky content -->
  <div sticky class="sticky-container" *ngIf="!submitted()">
    <tpm-tabs variant="primary" [active]="tab()" [tabs]="tabs" (activeTabChange)="onTabChange($any($event))"></tpm-tabs>
  </div>

  <!-- scrollable content -->
  <ng-container [ngSwitch]="tab()">
    <ng-container *ngSwitchCase="'contacts'">
      <ng-container *ngTemplateOutlet="contactsInfoTemplate"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'platform'">
      <ng-container *ngTemplateOutlet="feedbackFormTemplate"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'netzeBw'">
      <ng-container *ngTemplateOutlet="feedbackFormTemplate"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="submit-message-container">
        <p class="headline-2">{{ "CONTACT_DIALOG.feedbackSubmittedMessage" | translate }}</p>
      </div>
    </ng-container>
  </ng-container>

  <!-- footer -->
  <p footer class="inner-html-content" [innerHTML]="'CONTACT_DIALOG.footer' | translate"></p>
</tpm-dialog-frame>

<!-- Contact info template -->
<ng-template #contactsInfoTemplate>
  <h4 class="h4">{{ "CONTACT_DIALOG.userInfoHeader" | translate }}</h4>
  <tpm-card rounded-8 border-50 class="contact-info-card">
    <div class="contact-info">
      <div class="contact-info__avatar">
        <tpm-icon primary icon="gpi-circled-user"></tpm-icon>
      </div>
      <div class="body-sm contact-info__details">
        <h5 class="h5">{{ person()?.givenName }} {{ person()?.familyName }}</h5>
        <p>{{ person()?.role }}, {{ person()?.company }}</p>
        <p>{{ "CONTACT_DIALOG.userInfo.phone" | translate }}: {{ person()?.phoneNumber }}</p>
        <p>{{ "CONTACT_DIALOG.userInfo.email" | translate }}: {{ person()?.email }}</p>
        <p>{{ person()?.address }}</p>
      </div>
    </div>
  </tpm-card>
  <h6 class="h6">{{ "CONTACT_DIALOG.socialMediaHeader" | translate }}</h6>
  <div class="social-media-icons">
    <a *ngFor="let icon of socialMediaIcons" class="social-media-icons__link" target="_blank" [attr.href]="icon.url">
      <div class="social-media-icons__image-container">
        <img class="social-media-icons__image" [ngSrc]="icon.path" [alt]="icon.name" fill />
      </div>
    </a>
  </div>
</ng-template>

<!-- Feedback form template -->
<ng-template #feedbackFormTemplate>
  <form name="contactForm" class="feedback-form" [formGroup]="form">
    <h4 class="h4">{{ feedbackFormHeader() | translate }}</h4>
    <p class="body-md">{{ feedbackFormDescription() | translate }}</p>
    <div class="input-field">
      <h6 class="h6 required">{{ "CONTACT_DIALOG.feedbackForm.feedbackTopicLabel" | translate }}</h6>
      <div class="input-field__radio-group">
        <tpm-radio
          *ngFor="let option of feedbackTopicsOptions()"
          data-cy="feedbackTopic"
          formControlName="topic"
          [label]="option.label"
          [value]="option.value"
        ></tpm-radio>
      </div>
    </div>
    <div class="input-field" *ngIf="topicControl.value === 'errors'">
      <label class="input-field__label required">
        {{ "CONTACT_DIALOG.feedbackForm.feedbackErrorTypeLabel" | translate }}
      </label>
      <tpm-select
        data-cy="feedbackErrorType"
        formControlName="occurred"
        appearance="outline"
        [placeholder]="'APP.PLACEHOLDER' | translate"
        [options]="occuredErrorsOptions"
      ></tpm-select>
    </div>
    <div class="input-field">
      <label class="input-field__label required">{{ "CONTACT_DIALOG.feedbackForm.messageLabel" | translate }}</label>
      <textarea
        class="input-field__textarea"
        [class.required-error]="textControl.dirty && textControl.invalid"
        [rows]="5"
        [placeholder]="'CONTACT_DIALOG.feedbackForm.messagePlaceholder' | translate"
        formControlName="text"
      ></textarea>
    </div>
    <p
      class="body-sm inner-html-content required-note"
      [innerHTML]="'CONTACT_DIALOG.feedbackForm.requiredFieldsNote' | translate"
    ></p>
  </form>
</ng-template>
